export default "__VITE_ASSET__DWMWoaXr__"